<section class="mx-auto flex max-w-7xl flex-col px-4 pb-12 lg:pb-20">
	<!-- <h2
		class="scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
	>
		Why Tassie Tours
	</h2> -->
	<div class="mx-auto mt-6 grid w-full max-w-7xl grid-cols-2 gap-8 pb-12 lg:mt-12 lg:grid-cols-4">
		<div class="col-span-1 flex w-full flex-col">
			<enhanced:img
				src="/src/lib/assets/illustrations/adventure.png?w=144"
				class="h-36 w-36"
				alt="Small groups"
				sizes="144px"
				loading="lazy"
			/>
			<h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">Small groups</h3>
			<p class="lg:text-md text-sm">
				Most of our Tasmania tours are small, between 10 & 20 travellers.
			</p>
		</div>
		<div class="col-span-1 flex w-full flex-col">
			<enhanced:img
				src="/src/lib/assets/illustrations/mountain.png?w=144"
				class="h-36 w-36"
				alt="Local Knowledge"
				sizes="144px"
				loading="lazy"
			/>
			<h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">Local Knowledge</h3>
			<p class="lg:text-md text-sm">
				Our team of guides, bring a wealth of knowledge and passion to your journey.
			</p>
		</div>
		<div class="col-span-1 flex w-full flex-col">
			<enhanced:img
				src="/src/lib/assets/illustrations/planning.png?w=144"
				class="h-36 w-36"
				alt="Experienced Guides"
				sizes="144px"
				loading="lazy"
			/>
			<h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">Experienced guides</h3>
			<p class="lg:text-md text-sm">
				We have a wide range of experience when it comes to travelling Tasmania. We have a passion
				for all things Tasmania!
			</p>
		</div>

		<div class="col-span-1 flex w-full flex-col">
			<enhanced:img
				src="/src/lib/assets/illustrations/swimming.png?w=144"
				class="h-36 w-36"
				alt="Relaxed Crew"
				sizes="144px"
				loading="lazy"
			/>
			<h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">Relaxed crew</h3>
			<p class="lg:text-md text-sm">
				We are a relaxed, fun bunch so don't be afraid to make suggestions. We'll likely accommodate
				special requests.
			</p>
		</div>
	</div>
</section>
